const techs = [

    ['HTML, CSS, SCSS, JavaScript', 3],
    ['ReactJS', 3],
    ['BootStrap & Tailwind', 3],
    ['C, C++, Java, Python', 3],
    ['UI Design in Figma', 2],
    ['Firebase', 2],
    ['APIs', 2],
    ['Django', 1],

]

export default techs